export function getPlatformDisplayName(platform) {
  const rawPlatform = String(platform || '').trim();
  const normalizedPlatform = rawPlatform.toUpperCase();

  if (normalizedPlatform.startsWith('CUSTOM_')) return 'Custom Endpoint';

  switch (normalizedPlatform) {
    case 'OPENAI': return 'OpenAI';
    case 'CLAUDE': return 'Claude';
    case 'GEMINI': return 'Gemini';
    case 'MISTRAL': return 'Mistral';
    case 'OPENROUTER': return 'OpenRouter';
    case 'GROK': return 'Grok';
    default: return rawPlatform;
  }
}